import React from "react";
import Navbar from "../../../components/atoms/Navbar";
import styles from "./style.module.css";

const HeadFoot = (props) => {
  return (
    <div className={styles.HeadFoot}>
      <div className={styles.header}>
        <Navbar logo={props.logo} />
      </div>
      <div className={styles.middleChild}>{props.children}</div>
    </div>
  );
};

export default HeadFoot;
